/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUpdateRoomNoteRequestFromJSON(json) {
    return StreemApiUpdateRoomNoteRequestFromJSONTyped(json, false);
}
export function StreemApiUpdateRoomNoteRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'text': !exists(json, 'text') ? undefined : json['text'],
        'authorSid': !exists(json, 'author_sid') ? undefined : json['author_sid'],
    };
}
export function StreemApiUpdateRoomNoteRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'text': value.text,
        'author_sid': value.authorSid,
    };
}
//# sourceMappingURL=StreemApiUpdateRoomNoteRequest.js.map